import { useQuery, useMutation } from '@tanstack/react-query';
import { checkMerchantOrBCAPI, getBankList } from 'utils/API/Merchant APIs/MerchantApiCalls';
import { createBeneficiaryApi, verifyBeneficiaryPennyDropApi } from 'utils/API/Merchant APIs/UpdatedAPIs/DMTUpdatedAPICalls';
import { QUERY_KEYS } from './QueryKeys';

export const useGetBankList = () => {
    return useQuery({
        queryKey: QUERY_KEYS.BANK_LIST,
        queryFn: getBankList,
        select: (data) => data?.data?.data || [],
        staleTime: 1000 * 60 * 60 * 24, // 24 hours
        refetchOnWindowFocus: false
    });
};

export const useCheckMerchantStatus = (agentId) => {
    return useQuery({
        queryKey: [...QUERY_KEYS.CHECK_MERCHANT_OR_BC, agentId],
        queryFn: () => checkMerchantOrBCAPI({ agentid: agentId }),
        enabled: !!agentId,
        select: (data) => data?.data,
        refetchOnWindowFocus: false
    });
};

export const useCreateBeneficiary = () => {
    return useMutation({
        mutationFn: createBeneficiaryApi
    });
};

export const useVerifyBeneficiaryPennyDrop = () => {
    return useMutation({
        mutationFn: verifyBeneficiaryPennyDropApi
    });
};
